@if (!hideHeader) {
  <admin-app-header class="lay-wrapper lay-wrapper--header mat-elevation-z8"></admin-app-header>
}
<div class="main-content-wrapper">
  <router-outlet id="main-content"></router-outlet>
</div>
<coin-translation-viewer-banner></coin-translation-viewer-banner>
